module.exports = __webpack_public_path__ + "static/img/gargoyle.e035a5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/gargoyle.png
// module id = eCIp
// module chunks = 0